import React from 'react';
import PropTypes from 'prop-types';

const SeoTitleView = ({ tag, heading }) => {
  const Tag = tag;

  return (
    <div id="site-header-title" className="site-header-title">
      <Tag className="bvs-header bvs-ellipsis">
        {heading}
      </Tag>
    </div>
  );
};

SeoTitleView.propTypes = {
  tag: PropTypes.string,
  heading: PropTypes.string.isRequired,
};

SeoTitleView.defaultProps = {
  tag: 'h1',
};

export default SeoTitleView;
